import React from 'react';
import Select from 'app/components/presentation/forms/Select';
import { getLanguageById, USER_LANGUAGES, isLanguageId } from 'app/constants/enums/Language';
import { T } from 'app/components/localization';
import { LanguageId } from 'app/constants/enums/Language/data';

interface IProps {
  onChange: (language: LanguageId) => void;
  value: LanguageId;
  labelId?: string;
  labelRef?: React.RefObject<HTMLLabelElement>;
}

export default function AllLanguages({ value, onChange = () => {}, labelId, labelRef }: IProps) {
  return (
    <T>{t =>
      <Select
        selectedId={value}
        renderOption={id => {
          if (isLanguageId(id)) {
            const { getName, getNative } = getLanguageById(id);
            const name = getName(t);
            const native = getNative(t);
            return name === native ? name : `${name} - (${native})`;
          } else {
            throw new Error(`Expected a LanguageId; given: ${id}`);
          }
        }}
        optionIds={USER_LANGUAGES.map(({ id }) => id)}
        onSelect={(id) => {
          if (isLanguageId(id)) {
            onChange(id);
          } else {
            throw new Error(`Expected a LanguageId; given: ${id}`);
          }
        }}
        labelId={labelId}
        labelRef={labelRef}
      />
    }</T>
  );
}
